<form style="width: 400px; min-width: 50%">
  <h1 mat-dialog-title>{{'Communications.Scheduler.addSchedule.header' | translate}}</h1>
  <div mat-dialog-content>
    <mat-form-field class="col-12">
      <mat-label>{{'Communications.Scheduler.lblName' | translate}}</mat-label>
      <input type="text" matInput placeholder="{{'Communications.Scheduler.lblName' | translate}}" [(ngModel)]="schedule.name" [ngModelOptions]="{standalone: true}" maxlength="200"/>
    </mat-form-field>
    <mat-form-field class="col-12">
      <mat-label>{{'Communications.Scheduler.lblSelectFrom' | translate}}</mat-label>
      <mat-select [(ngModel)]="schedule.senderId" [ngModelOptions]="{standalone: true}">
        @for (sender of senderlist; track sender) {
          <mat-option [value]="sender.id"> {{sender.value}} </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="col-12">
      <mat-label>{{'Communications.Scheduler.lblSubject' | translate}}</mat-label>
      <input type="text" matInput placeholder="{{'Communications.Scheduler.lblSubject' | translate}}" [(ngModel)]="schedule.subject" [ngModelOptions]="{standalone: true}" maxlength="255"/>
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="OnSave()">{{'btnSave' | translate}}</button>&nbsp;
    <button mat-raised-button color="secondary" (click)="OnCancel()">{{'btnCancel' | translate}}</button>
  </div>
</form>